import {Component, Input, OnInit} from '@angular/core';
import {ServizioMensaRicaricaDetailDTO, Operazione} from "../../../core/api/generated";
import { IonToolbar, IonTitle, IonButtons, IonButton, IonIcon, IonGrid, IonRow, IonCol, IonItem, IonLabel, IonText, IonAccordionGroup, IonAccordion, ModalController } from '@ionic/angular/standalone';
import { TranslocoModule, TranslocoService, provideTranslocoScope } from '@jsverse/transloco';
import { parseISO, isValid, format } from 'date-fns';


@Component({
    selector: 'app-dettaglio-ricarica-modal',
    templateUrl: './dettaglio-ricarica-modal.component.html',
    styleUrls: ['./dettaglio-ricarica-modal.component.scss'],
    imports: [IonToolbar, IonTitle, IonButtons, IonButton, IonIcon, IonGrid, IonRow, IonCol, IonItem, IonLabel, IonText, IonAccordionGroup, IonAccordion, TranslocoModule],
    providers: [provideTranslocoScope('shared')]
})
export class DettaglioRicaricaModalComponent  implements OnInit {
  currentRicarica: ServizioMensaRicaricaDetailDTO = {}

  get modalTitle(): string {
    return this.transloco.translate('shared.dettaglio_ricarica.title');
  }

  @Input() set ricarica(ricarica: ServizioMensaRicaricaDetailDTO) {
    this.currentRicarica = ricarica;

  }
  constructor( private modalController: ModalController,
               private transloco: TranslocoService,) { }

  ngOnInit() {}

  joinOperazioni(operazioni?: Array<Operazione>) {
    if (!operazioni || operazioni.length === 0) return '';
    return operazioni.map(o => o.descrizione ?? '').filter(Boolean).join(', ');
  }

  /** Data ricarica formattata `dd/MM/yyyy`. Data ISO dal BE: `parseISO` + guardia `isValid`
   *  per non passare mai un Invalid Date a `format`; se non interpretabile ritorna il grezzo. */
  formatData(valore?: string): string {
    if (!valore) return '';
    const d = parseISO(valore);
    return isValid(d) ? format(d, 'dd/MM/yyyy') : valore;
  }

  /** Data-ora operazione formattata `dd/MM/yyyy HH:mm` (coerente con la timeline pratiche). */
  formatDataOra(valore?: string): string {
    if (!valore) return '';
    const d = parseISO(valore);
    return isValid(d) ? format(d, 'dd/MM/yyyy HH:mm') : valore;
  }

  goToBack() {
    this.modalController.dismiss().then(r => console.log('Dettaglio ricarica dismiss'))
  }
}
